var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.808058 0.808058C1.05214 0.563981 1.44786 0.563981 1.69194 0.808058L5 4.11612L8.30806 0.808058C8.55214 0.563981 8.94786 0.563981 9.19194 0.808058C9.43602 1.05214 9.43602 1.44786 9.19194 1.69194L5.88388 5L9.19194 8.30806C9.43602 8.55214 9.43602 8.94786 9.19194 9.19194C8.94786 9.43602 8.55214 9.43602 8.30806 9.19194L5 5.88388L1.69194 9.19194C1.44786 9.43602 1.05214 9.43602 0.808058 9.19194C0.563981 8.94786 0.563981 8.55214 0.808058 8.30806L4.11612 5L0.808058 1.69194C0.563981 1.44786 0.563981 1.05214 0.808058 0.808058Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.2ae9f0e689797db7077fabf2d41d2213.svg";
export { ForwardRef as ReactComponent };